import React from "react";
import {Pagination} from "zina-dogi-react";

const titles = ["Customer Team", "Category", "Sub-Category", "Service-Unit", "Budget", "Budget Consumed"];

const MasterBudgetTable = ({list, pagination, ...props}) => {
    const {className} = props;
    const voaTable_op = {
        className: ["voa_table", className].join(" ")
    };
    return (
        <div {...voaTable_op}>
            <br/>
            <div className="content">
                <table className="table table-bordered table-striped">
                    <thead className="thead-dark">
                    <tr>
                        {titles &&
                        titles.map((title, index) => (
                            <th key={`cpo_title_${index}`} scope="col">
                                {title}
                            </th>
                        ))}
                    </tr>
                    </thead>
                    <tbody>{computeRows(list)}</tbody>
                </table>
            </div>
            <Pagination {...pagination} />
        </div>
    );
};

const computeRows = list => {
    const values = Object.values(list);
    if (values.length > 0) {
        return values.map((master_budget, i) => {
            return (
                <tr key={`voa_${i}`} style={{textAlign: "center"}}>
                    <td>{master_budget.customer_team_name}</td>
                    <td>{master_budget.category_display}</td>
                    <td>{master_budget.sub_category_display}</td>
                    <td>{master_budget.service_unit_display}</td>
                    <td>{master_budget.budget}</td>
                    <td>{master_budget.budget_consume}</td>
                </tr>
            );
        });
    } else {
        return (
            <tr>
                <td colSpan={titles.length}>No data found</td>
            </tr>
        );
    }
};

export default MasterBudgetTable;
